import React from 'react';
import { FMessage } from '../../hoc/IntlComponents';

export const AttensionBlock = () => (
  <div className="warning-wrapper">
    <b>
      <FMessage id="main.attension" />
    </b>
    &nbsp; <FMessage id="transfer-by-api.attension" />
  </div>
);
